import { useCallback, useState } from 'react';
import { markChatAsSeen, markChatAsUnread } from '../services/patient';
import type { ToastType } from '../providers/ToastProvider';

export function useMessageActions(
    refreshMetadata: () => Promise<void>,
    showToast: (msg: string, type: ToastType) => void
) {
    const [markingSeenId, setMarkingSeenId] = useState<string | null>(null);
    const [markingUnreadId, setMarkingUnreadId] = useState<string | null>(null);

    const handleMarkAsSeen = useCallback(
        async (e: React.MouseEvent, patientId: string) => {
            e.stopPropagation();
            setMarkingSeenId(patientId);
            try {
                await markChatAsSeen(patientId);
                await refreshMetadata();
            } catch {
                showToast('Failed to mark as seen', 'error');
            } finally {
                setMarkingSeenId(null);
            }
        },
        [refreshMetadata, showToast]
    );

    const handleMarkAsUnread = useCallback(
        async (e: React.MouseEvent, patientId: string) => {
            e.stopPropagation();
            setMarkingUnreadId(patientId);
            try {
                await markChatAsUnread(patientId);
                await refreshMetadata();
            } catch {
                showToast('Failed to mark as unread', 'error');
            } finally {
                setMarkingUnreadId(null);
            }
        },
        [refreshMetadata, showToast]
    );

    return { markingSeenId, markingUnreadId, handleMarkAsSeen, handleMarkAsUnread };
}
